import { render, staticRenderFns } from "./child.vue?vue&type=template&id=1baac99a&scoped=true&"
import script from "./child.vue?vue&type=script&lang=js&"
export * from "./child.vue?vue&type=script&lang=js&"
import style0 from "./child.vue?vue&type=style&index=0&id=1baac99a&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baac99a",
  null
  
)

export default component.exports